import{Decoration_Type as e}from"ricos-schema";class t{constructor(){this.type=e.UNRECOGNIZED}getDecoration(){return{}}fromCustomStyle(r){return new t}toCustomStyle(){return{}}overrideWith(r){return r}}export{t as EmptyDecoration};
//# sourceMappingURL=empty-decoration.js.map
